import React, { useCallback } from 'react'

import { Dialog, DialogContent } from '@material-ui/core'

import SectionSubtitle from '~/components/sections/SectionSubtitle'
import SectionTitle from '~/components/sections/SectionTitle'
import translate from '~/locale'

import FacebookForm from '../FacebookForm'

type FacebookFormDialogProps = {
  open?: boolean
  onSuccess?: () => void
  onClose?: () => void
}

const FacebookFormDialog: React.FC<FacebookFormDialogProps> = ({
  open = false,
  onSuccess,
  onClose,
}) => {
  const handleSuccess = useCallback(() => {
    if (onClose) {
      setTimeout(() => onClose(), 3000)
    }

    if (onSuccess) {
      onSuccess()
    }
  }, [onSuccess, onClose])

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg">
      <DialogContent>
        <SectionTitle>{translate('earlyaccess_popup_title')}</SectionTitle>
        <SectionSubtitle>
          {translate('earlyaccess_popup_subtitle')}
        </SectionSubtitle>
        <FacebookForm onSuccess={handleSuccess} classeName="my-4" />
      </DialogContent>
    </Dialog>
  )
}

export default FacebookFormDialog
